module.exports = __webpack_public_path__ + "img/structure02.7914d115.svg";